<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Sunting Informasi Perusahaan</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama Perusahaan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.name" placeholder="Ketik Nama Pekerja">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama Lengkap Perusahaan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.fullname" placeholder="Ketik Nama Lengkap Perusahaan">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Alamat Perusahaan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.address" placeholder="Ketik Alamat Perusahaan">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Email<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.email" placeholder="Ketik Email">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nomor Telefon<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.phone_number" placeholder="Ketik Nomor Telefon">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nomor Fax<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.fax_number" placeholder="Ketik Nomor Fax">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12">
                      <div class="input-group">
                        <label class="label">Ketik dan Saran<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.ketik_saran_number" placeholder="Ketik Nomor Ketik dan Saran">
                      </div>
                    </div>
                  </div>
                  
                  <div class="row row-space">
                    <div class="col-xs-12 col-md-6">
                      <div class="input-group">
                        <label class="label">Bank Name<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.bank_name" placeholder="Ketik Nama Bank">
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 ">
                      <div class="input-group">
                        <label class="label">Bank Account<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.bank_account" placeholder="Ketik Nomor Rekening Bank">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12">
                      <div class="input-group">
                        <label class="label">Bank Account Name<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.bank_account_name" placeholder="Ketik Atas Nama Account Bank">
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 ">
                      <div class="input-group">
                        <label class="label">Website<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.website" placeholder="Ketik Website">
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Ubah</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import MultiSelect from 'vue-multiselect';

  export default {
    data () {
      return {
        options : {
          laborerType : this.$store.getters.getLaborerType
        },
        rangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        form : {
          name : '',
          fullname : '',
          address : '',
          email : '',
          phone_number : '',
          fax_number : '',
          ketik_saran_number : '',
          website : '',
          logo : '',
          bank_name : '',
          bank_account_name : '',
          bank_account : ''
        }
      }
    },
    props:['data'],
    components:{
      MultiSelect,
    },
    mounted () {
      let keys = Object.keys(this.form)
      for(var i in keys) this.form[keys[i]] = this.data[keys[i]] ? this.data[keys[i]] : ''
    },
    watch : {
      
    },
    methods : {
      validateForm(){
        var valid = true;
        var error = [];

        let required = [
          {title : 'Nama Perusahaan', variable : 'name'},
          {title : 'Nama Lengkap Perusahaan', variable : 'fullname'},
          {title : 'Alamat Perusahaan', variable : 'address'},
          {title : 'Email', variable : 'email'},
          {title : 'Nomor Telefon', variable : 'phone_number'},
          {title : 'Website', variable : 'website'},
          {title : 'Bank Account Name', variable : 'bank_account_name'},
          {title : 'Bank Account', variable : 'bank_account'},
          {title : 'Bank Name', variable : 'bank_name'},
          {title : 'Ketik dan Saran', variable : 'ketik_saran_number'},
        ]

        for(var i in required){
          if(this.form[required[i].variable] == '' || this.form[required[i].variable] == null){//Check all from 'required'
            valid = false;
            error.push(`${required[i].title} wajib diisi`);
          }
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(){
        let vm = this;
        if(vm.validateForm()){
          this.$http.put('/api/v1/company_profile', this.form)
          .then((resp)=>{
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$store.dispatch('triggerAlert', [true, [`Perusahaan berhasil disunting`]]);
            this.$emit('updateDetail');
            this.$emit('closeModal');
          })
          .catch((err)=>{
            console.log(err);
            this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
          })
        }
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}
</style>
